// extracted by mini-css-extract-plugin
module.exports = {"list":"SocialAvatar__list___blru4","story-border":"SocialAvatar__story-border___yK2D_"};